import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import RHService from '../../../../../services/rh-auth';
import Concurso from './concurso';


const ListarConcursos = () => {

    const [concursos, setConcursos] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [conc, setConc] = useState("");


    async function fetchConcursos() {
        const response = await RHService.listarConcursos();
        if (response.data.length >= 1) {
            setConcursos(response.data)
            setVazio(false)
        } else {
            setConcursos([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setConc(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o Edital?')) {
            await RHService.deletarConcurso(id)
            alert("Edital deletado com sucesso!")
            fetchConcursos();
        }
    }

    useEffect(() => {
        fetchConcursos();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/rh/concurso/editar/${conc}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setConcursos={setConcursos}
                        setVazio={setVazio}
                        fetchConcursos={fetchConcursos}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {concursos.map((conc, index) =>
                                <Concurso
                                    fetchConcursos={fetchConcursos}
                                    conc={conc}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarConcursos;